import { withErrorBoundary } from "@client/components/utils/ErrorBoundary";
import { cn } from "@client/utils/cn";

export const RoundPage = withErrorBoundary(
  ({
    className,
    title,
    description,
    cta,
    children,
  }: {
    className?: string;
    title: string;
    description?: string;
    cta?: React.ReactNode;
    children?: React.ReactNode;
  }) => (
    <div className="relative min-h-full p-4 flex mx-auto w-full max-w-content gap-6 flex-col">
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-3">
        <header>
          <h1 className="text-2xl font-bold">{title}</h1>
          {description && (
            <p className="text-xs text-muted-foreground">{description}</p>
          )}
        </header>
        {cta}
      </div>
      <div className={cn("flex-1", className)}>{children}</div>
    </div>
  ),
);
